import {subCategoryObject} from "@/content/services/2";
import ServiceSubCategoryPage from "@/ui/widgets/service-subcategory-page";

export default function Category2Service3Page() {
    const { category2Service3: subCategory } = subCategoryObject;
    return (<ServiceSubCategoryPage subCategory={subCategory} />)
}
